import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  fhirPatient: {},
  fhirPractitioner: {},

  ehrCorelationContext: {},
  ehrCorelationStatus: 'loading',
  ehrSubmitDocument: {},
  ehrSubmitDocumentStatus: 'loading',
};

const ehrReducer = createSlice({
  name: 'ehrSlice',
  initialState,
  reducers: {
    fhirPatient: (state, { payload }) => {
      state.fhirPatient = payload;
    },
    fhirPractitioner: (state, { payload }) => {
      state.fhirPractitioner = payload;
    },
    ehrCorelationContext: (state, { payload }) => {
      state.ehrCorelationContext = payload;
    },
    ehrCorelationStatus: (state, { payload }) => {
      state.ehrCorelationStatus = payload;
    },
    ehrSubmitDocument: (state, { payload }) => {
      state.ehrSubmitDocument = payload;
    },
    ehrSubmitDocumentStatus: (state, { payload }) => {
      state.ehrSubmitDocumentStatus = payload;
    },
  },
});

const { actions, reducer } = ehrReducer;

export const {
  fhirPatient,
  fhirPractitioner,
  ehrCorelationContext,
  ehrCorelationStatus,
  ehrSubmitDocument,
  ehrSubmitDocumentStatus,
} = actions;

export default reducer;
